const login = {
    "LOGIN_ROW1":"Academia",
    "LOGIN_ROW2":"Națională",
    "LOGIN_ROW3":"de Șah",
    "LOGIN_COPYRIGHT":"Academia de Șah",
    "LOGIN_FORM_WELCOME":"Добро пожаловать!",
    "LOGIN_FORM_SELECT_METHOD":"Выберите один из способов входа",
    "LOGIN_FORM_PRIMARY_BUTTON_LABEL":"Войти",
    "LOGIN_FORM_FACEBOOK_BUTTON_LABEL":"Войти с Facebook",
    "LOGIN_FORM_GOOGLE_BUTTON_LABEL":"Войти с Google",
    "LOGIN_FORM_LOGIN_PLACEHOLDER":"Логин",
    "LOGIN_FORM_PASSWORD_PLACEHOLDER":"Пароль",
    "BTN_SIGNOUT":"Выйти из системы",
    "LOGIN_FORM_REGISTER_BUTTON":"Зарегистрироваться",
    "LOGIN_FORM_FORGET_PASSWORD_BUTTON":"Забыли пароль?",
    "REGISTER_FORM_WELCOME":"Регистрация",
    "REGISTER_FORM_FIRST_NAME_PLACEHOLDER":"Ваше Имя",
    "REGISTER_FORM_LAST_NAME_PLACEHOLDER":"Фамилия",
    "REGISTER_FORM_LOGIN_PLACEHOLDER":"Адрес эл.почты",
    "REGISTER_FORM_PASSWORD_PLACEHOLDER":"Придумайте пароль",
    "REGISTER_FORM_PRIMARY_BUTTON_LABEL":"Создать аккаунт",
    "REGISTER_FORM_PHONE_PLACEHOLDER":"Номер телефона",
    "REGISTER_FORM_FIRST_NAME_LABEL":"Имя",
    "REGISTER_FORM_LAST_NAME_LABEL":"Фамилия",
    "REGISTER_FORM_EMAIL_LABEL":"Адрес эл. почты",
    "REGISTER_FORM_EMAIL_PLACEHOLDER":"example@sah.com",
    "REGISTER_FORM_PASSWORD_LABEL":"Пароль",
    "REGISTER_FORM_BIRTHDAY_LABEL":"Дата рождения",
    "REGISTER_FORM_PHONE_LABEL":"Номер контактного телефона",
    "POPUP_FAIL_HEADER":"Не удалось аутентифицироваться",
    "LBL_BTN_REGISTER":"Зарегистрироваться",
};
export default login